import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "chat-empty"
};
const _hoisted_2 = {
  class: "center-container"
};
const _hoisted_3 = {
  class: "role-list"
};
const _hoisted_4 = ["onClick"];
export default /*@__PURE__*/_defineComponent({
  __name: 'MessageListEmpty copy',
  emits: ['onPrompt'],
  setup(__props, {
    emit: __emit
  }) {
    const promptList = [{
      prompt: '今天气怎么样?'
    }, {
      prompt: '写一首好听的诗歌?'
    }]; // prompt 列表
    const emits = __emit;
    /** 选中 prompt 点击 */
    const handlerPromptClick = async ({
      prompt
    }) => {
      emits('onPrompt', prompt);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "title"
      }, "知派 AI", -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(promptList, prompt => {
        return _createElementVNode("div", {
          class: "role-item",
          key: prompt.prompt,
          onClick: $event => handlerPromptClick(prompt)
        }, _toDisplayString(prompt.prompt), 9, _hoisted_4);
      }), 64))])])]);
    };
  }
});